import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  EmbeddedViewRef,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalService } from '~app/shared/services/modal/modal.service';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
})
export class ModalContainerComponent implements OnInit, OnDestroy {
  public componentRef: ComponentRef<any>;
  public templateRef: EmbeddedViewRef<any>;
  public modalsOpened = new Array<ComponentRef<any> | EmbeddedViewRef<any>>();
  public isModalVisible: boolean;
  public viewHeight: number;
  private readonly ngUnsubscribe = new Subject();

  @ViewChild('modalContent', { static: true }) private readonly modalContent: ElementRef;

  constructor(
    private readonly modal: ModalService,
    private readonly vcr: ViewContainerRef,
    private readonly render: Renderer2,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.viewHeight = window.innerHeight;
    this.isModalVisible = false;
    this.modal.componentRef.pipe(takeUntil(this.ngUnsubscribe)).subscribe(d => {
      if (d?.comp) {
        this.openModal(d.comp, d.message);
      } else {
        this.closeModal();
      }
      this.isModalVisible = this.modalsOpened.length > 0;
      this.cdr.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public closeModal(): void {
    if (this.modalsOpened.length > 0) {
      this.modalsOpened.forEach((modal, index, modalList) => {
        modal.destroy();
        modalList.splice(index, 1);
      });
    }
  }

  private openModal(comp: Type<{}> | TemplateRef<{}>, message?: string): void {
    if (this.isModalVisible) {
      console.warn('A modal was already visible');
      this.closeModal();
    }

    if (comp instanceof TemplateRef) {
      this.templateRef = this.vcr.createEmbeddedView(comp);
      this.templateRef.rootNodes.forEach(node => {
        this.render.appendChild(this.modalContent.nativeElement, node);
      });
      this.modalsOpened.push(this.templateRef);
    } else if (comp instanceof Type) {
      this.componentRef = this.vcr.createComponent(comp, { projectableNodes: this.generateNgContent(message) });
      this.render.appendChild(this.modalContent.nativeElement, this.componentRef.location.nativeElement);
      this.modalsOpened.push(this.componentRef);
    }
  }

  private generateNgContent(text: string): [[any]] {
    const element = this.render.createText(text);
    return [[element]];
  }
}
